import React from 'react';
import style from './style.scss';
import {Collapse} from 'react-collapse';

class CollapseFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpened: this.props.value,
      title: this.props.title
    }
  }

  handleCollapse() {
    this.setState({
      isOpened: !this.state.isOpened
    })
  }

  render() {
    return (
      <section className="collapse-container">
        <h2 className={this.state.isOpened ? 'title-collapse open' : 'title-collapse'} onClick={this.handleCollapse.bind(this)}>{this.props.title}</h2>
        <Collapse isOpened={this.state.isOpened}>
          {
            this.props.children
          }
        </Collapse>
      </section>
    );
  }
}

CollapseFilter.defaultProps = {
  value: false,
  title: 'This is title'
}

export default CollapseFilter;


// WEBPACK FOOTER //
// ./components/partials/collapse/CollapseFilter.jsx